import { QueryKeys } from '@/consts';
import { statsRepository } from '@/repositories';
import { useQuery } from '@tanstack/react-query';

type UseTopGameActivitiesOptions = {
	limit?: number;
	enabled?: boolean;
	staleTime?: number;
};

export const useTopGameActivities = (game: string, options: UseTopGameActivitiesOptions = {}) => {
	const { limit = 10, enabled = true, staleTime = 15_000 } = options;

	return useQuery({
		queryKey: [QueryKeys.TopActivitiesByGame, game, limit],
		queryFn: () => statsRepository.getTopActivitiesByGame(game, limit),
		staleTime,
		gcTime: 60_000,
		refetchOnWindowFocus: true,
		enabled,
	});
};
